import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { User } from './Auth';

export const useHubSpotRouteTracking = () => {
  const pathname = useLocation();

  useEffect(() => {
    const _hsq = window._hsq || [];

    _hsq.push(['setPath', window.location.href]);
    _hsq.push(['trackPageView']);
  }, [pathname]);
};

export const hubspotIdentifyUser = (user: User) => {
  const _hsq = window._hsq || [];
  _hsq.push(['identify', { email: user.email, name: user.name }]);
};
